<template>
    <form class="contactUpdate modify modify-contact warn-on-exit" method="post">
        <!-- Basic Information -->
        <fieldset>
            <div class="form-body">
                <div class="form-group">
                    <txt label="Notes" v-model="model.notes"></txt>
                </div>
            </div><!-- .form-body -->
        </fieldset>

        <div class="buttons">
            <button @click.prevent="store" class="btn btn-success btn-sml"><i class="icon icon-save"></i> Save</button>
        </div>
        </form>
</template>

<script>
    import Ckeditor from "../ckeditor/ckeditor";
    export default {
        components: {
            Ckeditor,
        },
        props: {
            name: { default: '' },
        },
        data() {
            return {
                token: window.Laravel.csrfToken,
                model: {
                    public_id: 0,
                    notes: '',
                },
                address: {}
            }
        },
        created() {
            this.$eventHub.$on('renewalSubmit', this.store);
            this.$eventHub.$on('setrenewal', this.setRenewal);
        },
        methods: {
            setRenewal(data) {
                this.model = this.$setData(data, this.model);
            },
            store(data) {
                this.$store('/api/renewal/post', this);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
        }
    }
</script>
